import { useCallback, useEffect, useState } from 'react';
import api from './api';
import sources from './sources';
import useGym from './use_gym';
import { WaiverListItem } from 'react/types/waiver';

interface UseWaivers {
  waivers: WaiverListItem[];
  setWaivers: (waivers: WaiverListItem[]) => void;
  reloadWaivers: () => void;
}

const useWaivers = (): UseWaivers => {
  const gym = useGym();
  const [waivers, setWaivers] = useState<WaiverListItem[]>([]);

  const reloadWaivers = useCallback(() => {
    api.get(sources.waivers(gym.id), { count: 1000 }).then((data) => {
      setWaivers(data);
    });
  }, [gym.id]);

  useEffect(() => {
    reloadWaivers();
  }, [reloadWaivers]);

  return { waivers, setWaivers, reloadWaivers };
};

export default useWaivers;
